import { createRouter, createWebHashHistory } from 'vue-router'

import home from '../views/home.vue'
import user from '../views/user.vue'
import main from '../views/main.vue'
import mall from '../views/mall.vue'
import taskMarket from '../views/task-market.vue'
import robotMarket from '../views/robot-market.vue'
import activeOrders from '../views/active-orders.vue'
import profile from '../views/profile.vue'
import robotArchive from '../views/robot-archive.vue'
import dispatchInvitations from '../views/dispatch-invitations.vue'
import dispatchWaiting from '../views/dispatch-waiting.vue'
import adminRevenue from '../views/admin-revenue.vue'
import adminOrders from '../views/admin-orders.vue'
import adminSdkDevices from '../views/admin-sdk-devices.vue'
import adminRobotArchives from '../views/admin-robot-archives.vue'
import adminDerasReviews from '../views/admin-deras-reviews.vue'
import adminDispatch from '../views/admin-dispatch.vue'
import adminExceptions from '../views/admin-exceptions.vue'
import adminUsers from '../views/admin-users.vue'
import adminOpenApiDoc from '../views/admin-openapi-doc.vue'
import openApiDoc from '../views/openapi-doc.vue'
import mobilePortal from '../views/mobile-portal.vue'
import mobileTaskPublish from '../views/mobile-task-publish.vue'
import pageone from '../views/pageone.vue'
import pagetwo from '../views/pagetwo.vue'
import login from '../views/login.vue'
import adminLogin from '../views/admin-login.vue'
import man from '../views/man.vue'
import dai from '../views/dai.vue'
import pagethree from '../views/pagethree.vue'
import pagefore from '../views/pagefore.vue'
import pagefive from '../views/pagefive.vue'
import pagesix from '../views/pagesix.vue'
import packone from '../views/packuser/packone.vue'
import packtwo from '../views/packuser/packtwo.vue'
import packthree from '../views/packuser/packthree.vue'
import packfore from '../views/packuser/packfore.vue'
import packfive from '../views/packuser/packfive.vue'
import packsix from '../views/packuser/packsix.vue'
import packseven from '../views/packuser/packseven.vue'
import packhome from '../views/packuser/packhome.vue'
import adminone from '../views/packadmin/adminone.vue'
import admintwo from '../views/packadmin/admintwo.vue'
import adminthree from '../views/packadmin/adminthree.vue'
import adminfore from '../views/packadmin/adminfore.vue'
import adminfive from '../views/packadmin/adminfive.vue'
import adminsix from '../views/packadmin/adminsix.vue'
import adminseven from '../views/packadmin/adminseven.vue'
import adminhome from '../views/packadmin/adminhome.vue'

const routes = [
  {
    path: '/',
    component: main,
    redirect: '/home',
    children: [
      { path: '/home', name: 'home', component: home },
      { path: '/user', name: 'user', component: user, meta: { requiresUser: true } },
      { path: '/mall', name: 'mall', component: mall, meta: { requiresUser: true } },
      { path: '/task-market', name: 'taskMarket', component: taskMarket },
      { path: '/admin/tasks', name: 'adminTaskMarket', component: taskMarket, meta: { requiresAdmin: true } },
      { path: '/robot-market', name: 'robotMarket', component: robotMarket, meta: { requiresAdmin: true } },
      { path: '/active-orders', name: 'activeOrders', component: activeOrders, meta: { requiresUser: true } },
      { path: '/dispatch-invitations', name: 'dispatchInvitations', component: dispatchInvitations, meta: { requiresUser: true } },
      { path: '/dispatch-waiting/:taskId', name: 'dispatchWaiting', component: dispatchWaiting, meta: { requiresUser: true } },
      { path: '/profile', name: 'profile', component: profile, meta: { requiresUser: true } },
      { path: '/robot-archive/:robotId', name: 'robotArchive', component: robotArchive, meta: { requiresUser: true } },
      { path: '/admin-revenue', name: 'adminRevenue', component: adminRevenue, meta: { requiresAdmin: true } },
      { path: '/admin/orders', name: 'adminOrders', component: adminOrders, meta: { requiresAdmin: true } },
      { path: '/admin/sdk-devices', name: 'adminSdkDevices', component: adminSdkDevices, meta: { requiresAdmin: true } },
      { path: '/admin/robot-archives', name: 'adminRobotArchives', component: adminRobotArchives, meta: { requiresAdmin: true } },
      { path: '/admin/deras-reviews', name: 'adminDerasReviews', component: adminDerasReviews, meta: { requiresAdmin: true } },
      { path: '/admin/dispatch', name: 'adminDispatch', component: adminDispatch, meta: { requiresAdmin: true } },
      { path: '/admin/exceptions', name: 'adminExceptions', component: adminExceptions, meta: { requiresAdmin: true } },
      { path: '/admin/users', name: 'adminUsers', component: adminUsers, meta: { requiresAdmin: true } },
      { path: '/admin/openapi-doc', name: 'adminOpenApiDoc', component: adminOpenApiDoc, meta: { requiresAdmin: true } },
      { path: '/openapi-doc', name: 'openApiDoc', component: openApiDoc },
      { path: '/mobile', name: 'mobilePortal', component: mobilePortal },
      { path: '/mobile-task-publish', name: 'mobileTaskPublish', component: mobileTaskPublish },
      { path: '/page1', name: 'page1', component: pageone },
      { path: '/page2', name: 'page2', component: pagetwo },
      { path: '/dai', name: 'dai', component: dai },
      { path: '/page3', name: 'pagethree', component: pagethree },
      { path: '/page4', name: 'pagefore', component: pagefore },
      { path: '/packone', name: 'packone', component: packone },
      { path: '/packtwo', name: 'packtwo', component: packtwo },
      { path: '/packthree', name: 'packthree', component: packthree },
      { path: '/packfore', name: 'packfore', component: packfore },
      { path: '/packfive', name: 'packfive', component: packfive },
      { path: '/packsix', name: 'packsix', component: packsix },
      { path: '/packseven', name: 'packseven', component: packseven },
      { path: '/packhome', name: 'packhome', component: packhome },
      { path: '/adminone', name: 'adminone', component: adminone, meta: { requiresAdmin: true } },
      { path: '/admintwo', name: 'admintwo', component: admintwo, meta: { requiresAdmin: true } },
      { path: '/adminthree', name: 'adminthree', component: adminthree, meta: { requiresAdmin: true } },
      { path: '/adminfore', name: 'adminfore', component: adminfore, meta: { requiresAdmin: true } },
      { path: '/adminfive', name: 'adminfive', component: adminfive, meta: { requiresAdmin: true } },
      { path: '/adminsix', name: 'adminsix', component: adminsix, meta: { requiresAdmin: true } },
      { path: '/adminhome', name: 'adminhome', component: adminhome, meta: { requiresAdmin: true } },
      { path: '/adminseven', name: 'adminseven', component: adminseven, meta: { requiresAdmin: true } },
      { path: '/pagefive', name: 'pagefive', component: pagefive },
      { path: '/pagesix', name: 'pagesix', component: pagesix }
    ]
  },
  { path: '/login', name: 'login', component: login },
  { path: '/deras-console', name: 'adminLogin', component: adminLogin },
  { path: '/man', name: 'man', component: man }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
